import { call, put, take, takeEvery } from "redux-saga/effects";

import {
  createCandidateMedia,
  getCandidateMedia,
  deleteCandidateMedia,
  updateCandidateMedia,
  createProjectMedia,
  fetchProjectMediaByWorkExperienceId,
  fetchProjectMediaByListOfWorkExperienceId,
  deleteProjectMedia,
  updateProjectMedia,
  getEducationDetails,
  getWorkExperienceDetails,
  getCertificates,
  deleteCertificates,
  deleteEducationDetails,
  deleteWorkExperience,
} from "../../helpers/backend_helper";

import {
  CREATE_SELF_INTRO_MEDIA,
  FETCH_SELF_INTRO_MEDIA,
  DELETE_SELF_INTRO_MEDIA,
  UPDATE_SELF_INTRO_MEDIA,
  CREATE_PROJECT_MEDIA,
  FETCH_PROJECT_MEDIA,
  FETCH_PROJECT_MEDIA_LIST,
  DELETE_PROJECT_MEDIA,
  UPDATE_PROJECT_MEDIA,
  FETCH_CANDIDATE_EDUCATION,
  FETCH_CANDIDATE_WORK_EXPERIENCE,
  FETCH_CANDIDATE_CERTIFICATIONS,
  DELETE_CANDIDATE_CERTIFICATIONS,
  DELETE_CANDIDATE_EDUCATION,
  DELETE_CANDIDATE_WORK_EXPERIENCE,
} from "./actionType";

import {
  createSelfIntroMediaSuccess,
  createSelfIntroMediaFailure,
  fetchSelfIntroMediaSuccess,
  fetchSelfIntroMediaFailure,
  deleteSelfIntroMediaSuccess,
  deleteSelfIntroMediaFailure,
  updateSelfIntroMediaSuccess,
  updateSelfIntroMediaFailure,
  createProjectMediaSuccess,
  createProjectMediaFailure,
  fetchProjectMediaSuccess,
  fetchProjectMediaFailure,
  fetchProjectMediaListSuccess,
  fetchProjectMediaListFailure,
  deleteProjectMediaSuccess,
  deleteProjectMediaFailure,
  updateProjectMediaSuccess,
  updateProjectMediaFailure,
  fetchCandidateEducationSuccess,
  fetchCandidateEducationFailure,
  fetchCandidateWorkExperienceSuccess,
  fetchCandidateWorkExperienceFailure,
  fetchCandidateCertificationsSuccess,
  fetchCandidateCertificationsFailure,
  deleteCandidateCertificationsSuccess,
  deleteCandidateCertificationsFailure,
  deleteCandidateEducationSuccess,
  deleteCandidateEducationFailure,
  deleteCandidateWorkExperienceSuccess,
  deleteCandidateWorkExperienceFailure,
} from "./action";

import { toast } from "react-toastify";

function* createSelfIntroMediaSaga(action) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  try {
    const response = yield call(createCandidateMedia, action.payload, config);
    yield put(createSelfIntroMediaSuccess(response.data));
    toast.success("Candidate profile picture uploaded successfully.");
  } catch (error) {
    yield put(createSelfIntroMediaFailure(error));
    toast.error("Error creating candidate media.");
  }
}

function* fetchSelfIntroMediaSaga(action) {
  try {
    const response = yield call(getCandidateMedia, action.payload);
    yield put(fetchSelfIntroMediaSuccess(response.data));
  } catch (error) {
    yield put(fetchSelfIntroMediaFailure(error));
    toast.error("Error fetching candidate media.");
  }
}

function* deleteSelfIntroMediaSaga(action) {
  try {
    const response = yield call(deleteCandidateMedia, action.payload);
    yield put(deleteSelfIntroMediaSuccess(response));
    toast.success("Candidate portfolio image deleted successfully.");
  } catch (error) {
    yield put(deleteSelfIntroMediaFailure(error));
    toast.error("Error deleting candidate portfolio image.");
  }
}

function* updateSelfIntroMediaSaga(action) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  const { id, formData } = action.payload;

  try {
    const response = yield call(updateCandidateMedia, id, formData, config);
    yield put(updateSelfIntroMediaSuccess(response.data));
    toast.success("Candidate profile picture updated successfully.");
  } catch (error) {
    yield put(updateSelfIntroMediaFailure(error));
    toast.error("Error updating candidate media.");
  }
}

function* createProjectMediaSaga(action) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  try {
    const response = yield call(createProjectMedia, action.payload, config);
    const { workExperienceId } = action.payload;
    yield put(
      createProjectMediaSuccess({
        workExperienceId,
        media: response.data,
      })
    );
    toast.success("Project image uploaded successfully.");
  } catch (error) {
    yield put(createProjectMediaFailure(error));
    toast.error("Error creating project media.");
  }
}

function* fetchProjectMediaSaga(action) {
  try {
    const response = yield call(
      fetchProjectMediaByWorkExperienceId,
      action.payload
    );
    yield put(
      fetchProjectMediaSuccess({
        workExperienceId: action.payload,
        media: response.data,
      })
    );
  } catch (error) {
    yield put(fetchProjectMediaFailure(error));
    toast.error("Error fetching project media.");
  }
}

function* fetchProjectMediaListSaga(action) {
  try {
    const response = yield call(
      fetchProjectMediaByListOfWorkExperienceId,
      action.payload
    );
    yield put(fetchProjectMediaListSuccess(response.data));
  } catch (error) {
    yield put(fetchProjectMediaListFailure(error));
    toast.error("Error fetching project media.");
  }
}

function* deleteProjectMediaSaga(action) {
  try {
    yield call(deleteProjectMedia, action.payload);
    yield put(deleteProjectMediaSuccess({ id: action.payload }));
    toast.success("Project image deleted successfully.");
  } catch (error) {
    yield put(deleteProjectMediaFailure(error));
    toast.error("Error deleting project media.");
  }
}

function* updateProjectMediaSaga(action) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  const { id, formData } = action.payload;
  try {
    const response = yield call(updateProjectMedia, id, formData, config);
    yield put(updateProjectMediaSuccess({ id, updatedMedia: response.data }));
    toast.success("Project image updated successfully.");
  } catch (error) {
    yield put(updateProjectMediaFailure(error));
    toast.error("Error updating project media.");
  }
}

function* fetchCandidateEducationSaga(action) {
  const { entity, id } = action.payload;
  try {
    const response = yield call(getEducationDetails, entity, id);
    yield put(fetchCandidateEducationSuccess(response.data));
  } catch (error) {
    yield put(fetchCandidateEducationFailure(error));
    toast.error("Error fetching candidate education details.");
  }
}

function* fetchCandidateWorkExperienceSaga(action) {
  const { entity, id } = action.payload;
  try {
    const response = yield call(getWorkExperienceDetails, entity, id);
    yield put(fetchCandidateWorkExperienceSuccess(response.data));
  } catch (error) {
    yield put(fetchCandidateWorkExperienceFailure(error));
    toast.error("Error fetching candidate work experience details.");
  }
}

function* fetchCandidateCertificationsSaga(action) {
  const { entity, id } = action.payload;
  try {
    const response = yield call(getCertificates, entity, id);
    yield put(fetchCandidateCertificationsSuccess(response.data));
  } catch (error) {
    yield put(fetchCandidateCertificationsFailure(error));
    toast.error("Error fetching candidate certifications.");
  }
}

function* deleteCandidateCertificationsSaga(action) {
  try {
    const response = yield call(deleteCertificates, action.payload);
    yield put(deleteCandidateCertificationsSuccess({ id: action.payload }));
    toast.success("Certificate deleted successfully.");
  } catch (error) {
    yield put(deleteCandidateCertificationsFailure(error));
    toast.error("Error deleting certificate.");
  }
}

function* deleteCandidateEducationSaga(action) {
  try {
    const response = yield call(deleteEducationDetails, action.payload);
    yield put(deleteCandidateEducationSuccess({ id: action.payload }));
    toast.success("Education details deleted successfully.");
  } catch (error) {
    yield put(deleteCandidateEducationFailure(error));
    toast.error("Error deleting education details.");
  }
}

function* deleteCandidateWorkExperienceSaga(action) {
  try {
    const response = yield call(deleteWorkExperience, action.payload);
    yield put(deleteCandidateWorkExperienceSuccess({ id: action.payload }));
    toast.success("Work experience deleted successfully.");
  } catch (error) {
    yield put(deleteCandidateWorkExperienceFailure(error));
    toast.error("Error deleting work experience.");
  }
}

export default function* watchCreateSelfIntroMedia() {
  yield takeEvery(CREATE_SELF_INTRO_MEDIA, createSelfIntroMediaSaga);
  yield takeEvery(FETCH_SELF_INTRO_MEDIA, fetchSelfIntroMediaSaga);
  yield takeEvery(DELETE_SELF_INTRO_MEDIA, deleteSelfIntroMediaSaga);
  yield takeEvery(UPDATE_SELF_INTRO_MEDIA, updateSelfIntroMediaSaga);
  yield takeEvery(CREATE_PROJECT_MEDIA, createProjectMediaSaga);
  yield takeEvery(FETCH_PROJECT_MEDIA, fetchProjectMediaSaga);
  yield takeEvery(FETCH_PROJECT_MEDIA_LIST, fetchProjectMediaListSaga);
  yield takeEvery(DELETE_PROJECT_MEDIA, deleteProjectMediaSaga);
  yield takeEvery(UPDATE_PROJECT_MEDIA, updateProjectMediaSaga);
  yield takeEvery(FETCH_CANDIDATE_EDUCATION, fetchCandidateEducationSaga);
  yield takeEvery(
    FETCH_CANDIDATE_WORK_EXPERIENCE,
    fetchCandidateWorkExperienceSaga
  );
  yield takeEvery(
    FETCH_CANDIDATE_CERTIFICATIONS,
    fetchCandidateCertificationsSaga
  );
  yield takeEvery(
    DELETE_CANDIDATE_CERTIFICATIONS,
    deleteCandidateCertificationsSaga
  );
  yield takeEvery(DELETE_CANDIDATE_EDUCATION, deleteCandidateEducationSaga);
  yield takeEvery(
    DELETE_CANDIDATE_WORK_EXPERIENCE,
    deleteCandidateWorkExperienceSaga
  );
}
